import React from 'react';
import { PhoneIcon, ClipboardListIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF } from '../data/content';
import { useQuoteModal } from '../contexts/QuoteModalContext';
interface CallBannerProps {
  headline: string;
  sub?: string;
}
export function CallBanner({
  headline,
  sub
}: CallBannerProps) {
  const {
    openQuote
  } = useQuoteModal();
  return <section className="w-full bg-forest-800" data-id="element-42" data-mp="1nj89bpb9uk5a">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-43" data-mp="1nk16bykfhva8">
        <div data-id="element-44" data-mp="1im9ibfmwmtbb">
          <p className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-45" data-mp="1wjy18hxevqdq">
            {headline}
          </p>
          {sub && <p className="mt-1 text-base text-forest-100" data-id="element-46" data-mp="1sh9qg4p509e4">{sub}</p>}
        </div>
        <div className="flex flex-wrap items-center gap-3" data-id="element-47" data-mp="37yjyh4p2wt07">
          <a href={PHONE_HREF} className="inline-flex shrink-0 items-center gap-3 rounded-md bg-ember-500 px-6 py-3.5 font-display text-xl uppercase tracking-wide text-ink-900 transition-transform duration-150 ease-out hover:-translate-y-0.5 hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-48" data-mp="38164gzwbn0gb">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-49" data-mp="38anz85bpin7j" />
            {PHONE_DISPLAY}
          </a>
          <button type="button" onClick={openQuote} className="inline-flex shrink-0 items-center gap-2 rounded-md border-2 border-white/40 px-5 py-3.5 font-display text-base uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-50" data-mp="3da0vthsdr8nb">
            <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-51" data-mp="2pilqdg5b4b7u" />
            Quote online
          </button>
        </div>
      </div>
    </section>;
}